(() => {
	let swiperInstances = [];

	const initSwiper = () => {
		const sliders = document.querySelectorAll('.js-programs-slider');

		sliders.forEach((el, i) => {
			const swiperClass = 'js-programs-slider-' + i;
			el.classList.add(swiperClass);

			const parent = el.parentElement;

			if (window.innerWidth < 768) {
				const swiper = new Swiper('.' + swiperClass, {
					loop: false,
					speed: 500,
					slidesPerView: 'auto',
					spaceBetween: 12,
					centerInsufficientSlides: true,
					watchOverflow: true,
					freeMode: {
						enabled: true,
						sticky: true
					}
				});
				swiperInstances.push(swiper);
			}
		});
	};

	const destroySwiper = () => {
		swiperInstances.forEach(swiper => {
			if (swiper && !swiper.destroyed) {
				swiper.destroy(true, true);
			}
		});
		swiperInstances = [];
	};

	const handleResize = () => {
		if (window.innerWidth >= 768) {
			destroySwiper();
		} else {
			if (swiperInstances.length === 0) {
				initSwiper();
			}
		}
	};

	// Debounce function
	function debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	// Debounce the resize handler with a delay of 200ms
	const debouncedHandleResize = debounce(handleResize, 200);

	// Initial setup
	initSwiper();

	// Add resize event listener with debounced function
	window.addEventListener('resize', debouncedHandleResize);
})();
